/**
 * Feature flag keys and mapped type.
 * Source of truth for FeatureKeys enum — used by FeatureFlagContext and UserAPI.
 */

export enum FeatureKeys {
  UI_ONLY = 'UI_ONLY', // Dummy feature flag to hide components from UI only
  DASHBOARD_PRODUCT_FILTER = 'DASHBOARD_PRODUCT_FILTER',
  FREEMIUM_FEATURES = 'FREEMIUM_FEATURES',
  DOMAIN_CONFIG_SECURITY_SCORE_CARD = 'DOMAIN_CONFIG_SECURITY_SCORE_CARD',
  IMPERVA = 'IMPERVA',
  HIDE_BETA_TAG = 'HIDE_BETA_TAG',
  HIDE_NEW_TAG = 'HIDE_NEW_TAG',
  AUTOMOX = 'AUTOMOX',
  DAILY_DIGEST_REPORT = 'DAILY_DIGEST_REPORT',
  EXPLOITED_COLUMN = 'EXPLOITED_COLUMN',
  AATI_SCORE_COLUMN = 'AATI_SCORE_COLUMN',
  REPORTS_CUSTOM_WIDGET = 'REPORTS_CUSTOM_WIDGET',
  BLACKDUCK_BIDIRECTIONAL_FLOW = 'BLACKDUCK_BIDIRECTIONAL_FLOW',
  BLACKDUCK_MULTI_PHASE_FILTER = 'BLACKDUCK_MULTI_PHASE_FILTER',
  BI_DIRECTIONAL_STATUS_BLACKDUCK = 'BI_DIRECTIONAL_STATUS_BLACKDUCK',
  DEPENDANT_FINDINGS_CONFIG = 'DEPENDANT_FINDINGS_CONFIG',
  BI_DIRECTIONAL_STATUS_COVERITY = 'BI_DIRECTIONAL_STATUS_COVERITY',
  CROSS_BU_FINDINGS_BY_TAG = 'CROSS_BU_FINDINGS_BY_TAG',
  RISK_QUANTIFICATION = 'RISK_QUANTIFICATION',
  ENABLE_FOR_REPORT_INGESTION_TOKEN = 'ENABLE_FOR_REPORT_INGESTION_TOKEN',
  IN_PROGRESS_SLA = 'IN_PROGRESS_SLA',
  EXPORT_COMMENTS_HISTORY = 'EXPORT_COMMENTS_HISTORY',
  FINDING_DETAILS_PDF = 'FINDING_DETAILS_PDF',
  PARTNER_FEATURES = 'PARTNER_FEATURES',
  RISK_SCORE_3_0 = 'RISK_SCORE_3_0',
  DISABLE_BIDIRECTIONAL_SYNC = 'DISABLE_BIDIRECTIONAL_SYNC',
  TICKET_RISK_SCORE_WIDGET = 'TICKET_RISK_SCORE_WIDGET',
  TICKET_SLA_MISSED_WIDGET = 'TICKET_SLA_MISSED_WIDGET',
  TICKET_RISK_TIMELINE = 'TICKET_RISK_TIMELINE',
  BU_CREATION = 'BU_CREATION',
  SLA_STATUS_BREACHED_CUSTOM_FIELD = 'SLA_STATUS_BREACHED_CUSTOM_FIELD',
  SNYK_APPEND_ORGANIZATION_IN_PROJECT = 'SNYK_APPEND_ORGANIZATION_IN_PROJECT',
  JFROG_VISION_VDOO = 'JFROG_VISION_VDOO',
  ARCHIVE_DELETED_PROJECTS = 'ARCHIVE_DELETED_PROJECTS',
  DISCOVERY_CYCODE_REPO_NAME_WITH_PROJECT = 'DISCOVERY_CYCODE_REPO_NAME_WITH_PROJECT',
  HACKERONEONE_BU_CHANGE = 'HACKERONEONE_BU_CHANGE',
  HIDE_VERSION_IN_BLACKDUCK_PROJECT = 'HIDE_VERSION_IN_BLACKDUCK_PROJECT',
  JFROG_XRAY_FETCH_REPOSITORY = 'JFROG_XRAY_FETCH_REPOSITORY',
  JFROG_XRAY_VERSION_SPECIFIC_INGESTION = 'JFROG_XRAY_VERSION_SPECIFIC_INGESTION',
  CONFIGURE_PROJECT_DASHBOARD = 'CONFIGURE_PROJECT_DASHBOARD',
  SNYK_PROJECTS_BY_TARGET = 'SNYK_PROJECTS_BY_TARGET',
  SNYK_USE_TARGETS_API = 'SNYK_USE_TARGETS_API',
  TENABLE_INFRASTRUCTURE_DEPRECATED = 'TENABLE_INFRASTRUCTURE_DEPRECATED',
  JIRA_TICKET_DISABLE_COMMENTS_SYNC = 'JIRA_TICKET_DISABLE_COMMENTS_SYNC',
  SONATYPE_LIFECYCLE_MULTI_STAGE_DISABLED = 'SONATYPE_LIFECYCLE_MULTI_STAGE_DISABLED',
  CYCODE_PULL_CLOUD_ACCOUNT_VIOLATIONS = 'CYCODE_PULL_CLOUD_ACCOUNT_VIOLATIONS',
  CYCODE_INGESTION_CONFIG_V2 = 'CYCODE_INGESTION_CONFIG_V2',
  CX_ONE_CONTAINER_SECURITY_INGESTION = 'CX_ONE_CONTAINER_SECURITY_INGESTION',
  EXCEPTION_MODULE = 'EXCEPTION_MODULE',
  JIRA_TICKET_CLOSURE_STATUS_SELECTION = 'JIRA_TICKET_CLOSURE_STATUS_SELECTION',
  APPCHECK = 'APPCHECK',
  SNYK_TARGET_ORIGIN = 'SNYK_TARGET_ORIGIN',
  VERSIONS = 'VERSIONS',
  UNIFIED_TICKET_TEMPLATE = 'UNIFIED_TICKET_TEMPLATE',
  HIDE_DEVELOPER_INSIGHT = 'HIDE_DEVELOPER_INSIGHT',
  PENTEST_MODULE = 'PENTEST_MODULE',
  IGNORE_VERSION_FROM_PROJECT_NAME = 'IGNORE_VERSION_FROM_PROJECT_NAME',
  NETSPARKER_SCAN_GROUP_DISCOVERY_NAME = 'NETSPARKER_SCAN_GROUP_DISCOVERY_NAME',
  RUNBOOK_TICKET_STATUS_CHANGE = 'RUNBOOK_TICKET_STATUS_CHANGE',
  MANDIANT_CTI = 'MANDIANT_CTI',

  EXECUTE_TOOL_SCAN = 'EXECUTE_TOOL_SCAN',
  HACKERONE_MANY_TO_ONE = 'HACKERONE_MANY_TO_ONE',
  MICROSOFT_DEFENDER_FOR_ENDPOINT_ADVANCED_HUNTING = 'MICROSOFT_DEFENDER_FOR_ENDPOINT_ADVANCED_HUNTING',
  RBVM_ASSETS = 'RBVM_ASSETS',
  ASSET_CATEGORIZATION_UI = 'ASSET_CATEGORIZATION_UI',
  AZURE_ONBOARDING = 'AZURE_ONBOARDING',
  SONARQUBE_COMPONENT_NAME_WITH_KEY = 'SONARQUBE_COMPONENT_NAME_WITH_KEY',
  ENABLE_ATS_INTEGRATION = 'ENABLE_ATS_INTEGRATION',
  WIZ_ATS_PROXY_AUTH_ENABLE = 'WIZ_ATS_PROXY_AUTH_ENABLE',
  ENABLE_AIKIDO = 'ENABLE_AIKIDO',
  HIERARCHY_SEVERITY_MAPPING = 'HIERARCHY_SEVERITY_MAPPING',
  SIMPLIFIED_ONBOARDING = 'SIMPLIFIED_ONBOARDING',
  ONBOARDING_ORGANISE_BY_MULTIPLE_TAGS = 'ONBOARDING_ORGANISE_BY_MULTIPLE_TAGS',
  TICKETING_CUSTOM_SEVERITY_RISK_RATING = 'TICKETING_CUSTOM_SEVERITY_RISK_RATING',
  RUNBOOK_SCHEDULED_RUNBOOK = 'RUNBOOK_SCHEDULED_RUNBOOK',
  CODE_CLASSIFICATION = 'CODE_CLASSIFICATION',
  WEB_AGENT_DISABLED = 'WEB_AGENT_DISABLED',
  ANYA_PERSONNAS = 'ANYA_PERSONNAS',
  ANYA_MODEL_SELECTION = 'ANYA_MODEL_SELECTION',
  ENABLE_CHECKMARXONE_SCAN_FILTERS = 'ENABLE_CHECKMARXONE_SCAN_FILTERS',
  NEW_TABLE_FILTER = 'NEW_TABLE_FILTER',
  RUNBOOK_HTTP_REQUEST_ACTION = 'RUNBOOK_HTTP_REQUEST_ACTION',
  RUNBOOK_UPDATE_TICKET_TASK = 'RUNBOOK_UPDATE_TICKET_TASK',
  CUSTOM_RISK_ENABLED = 'CUSTOM_RISK_ENABLED',
  MANAGE_SBOM_DISPLAY = 'MANAGE_SBOM_DISPLAY',
  SARIF_INTEGRATION = 'SARIF_INTEGRATION',
  IRIUS_RISK_FETCH_FROM_V2_API = 'IRIUS_RISK_FETCH_FROM_V2_API',
  GITHUB_BIDIRECTION_SUPPORT = 'GITHUB_BIDIRECTION_SUPPORT',
  ENABLE_GOOGLE_SCIM_PROVISIONING = 'ENABLE_GOOGLE_SCIM_PROVISIONING',
  MEND_FETCH_LICENSE_FINDINGS = 'MEND_FETCH_LICENSE_FINDINGS',
  UI_THEME = 'UI_THEME',
  ENABLE_LEANIX_V4_SUPPORT = 'ENABLE_LEANIX_V4_SUPPORT',
  AI_DISABLED = 'AI_DISABLED',
  DASHBOARD_RBAC = 'DASHBOARD_RBAC',
  ENABLE_GOOGLE_JIT_PROVISIONING = 'ENABLE_GOOGLE_JIT_PROVISIONING',
  ENABLE_DEPRECATED_PRISMA_CLOUD_TWISTLOCK = 'ENABLE_DEPRECATED_PRISMA_CLOUD_TWISTLOCK',
  OWASP_CWE_FILTER = 'OWASP_CWE_FILTER',
  GITHUB_ISSUES_CONFIG = 'GITHUB_ISSUES_CONFIG',
  EXCEPTION_MODULE_UPDATE = 'EXCEPTION_MODULE_UPDATE',
  EXCEPTION_GRANULAR_SCOPE = 'EXCEPTION_GRANULAR_SCOPE',
  AI_OVERVIEW_DASHBOARD = 'AI_OVERVIEW_DASHBOARD',
  AI_CODE_INSIGHTS = 'AI_CODE_INSIGHTS',
  AATIV2_SCORE = 'AATIV2_SCORE',
  CXONE_MANAGE_SBOM = 'CXONE_MANAGE_SBOM',
  DISABLE_TAG_GLOBAL_FILTER = 'DISABLE_TAG_GLOBAL_FILTER',
  NOWSECURE_LAST_SCAN_DATE_SUPPORT = 'NOWSECURE_LAST_SCAN_DATE_SUPPORT',
  RISK_TIERS = 'RISK_TIERS',
  ENABLE_GHAS_FOR_ENTERPRISE = 'ENABLE_GHAS_FOR_ENTERPRISE',
  SCAN_FREQUENCY_LIMITS = 'SCAN_FREQUENCY_LIMITS',
  GITGUARDIAN_OCCURRENCE_BASED_FINDINGS = 'GITGUARDIAN_OCCURRENCE_BASED_FINDINGS',
  GITGUARDIAN_PUBLIC_MONITORING = 'GITGUARDIAN_PUBLIC_MONITORING',
  FINDING_AQL_V2 = 'FINDING_AQL_V2',
  AQL_V2_PREVIEW = 'AQL_V2_PREVIEW',
  RESTRICTED_ROLE_ENABLE = 'RESTRICTED_ROLE_ENABLE',
  WIZ_PULL_ROOT_PROJECTS = 'WIZ_PULL_ROOT_PROJECTS',
  WIZ_ASSET_TYPE_TREE_SELECT = 'WIZ_ASSET_TYPE_TREE_SELECT',
  WIZ_SECRET_FINDINGS_ENABLE = 'WIZ_SECRET_FINDINGS_ENABLE',
  WIZ_FETCH_ALL_ASSETS_ENABLE = 'WIZ_FETCH_ALL_ASSETS_ENABLE',
  UPWIND_FETCH_ALL_ASSETS_ENABLE = 'UPWIND_FETCH_ALL_ASSETS_ENABLE',
  MICROSOFT_DEFENDER_FOR_ENDPOINT_ASSET_TAG_SELECTION_ENABLE = 'MICROSOFT_DEFENDER_FOR_ENDPOINT_ASSET_TAG_SELECTION_ENABLE',
  PRISMA_COMPUTE_ENABLE_IMAGE_VERSION_MAPPING = 'PRISMA_COMPUTE_ENABLE_IMAGE_VERSION_MAPPING',
  SLA_V2 = 'SLA_V2',
  TAG_INHERITANCE_OVERRIDE = 'TAG_INHERITANCE_OVERRIDE',
  GHAS_MAPPING_BASED_ON_GITHUB_STATUS = 'GHAS_MAPPING_BASED_ON_GITHUB_STATUS',
  TICKET_FOR_RESOLVED_FINDINGS = 'TICKET_FOR_RESOLVED_FINDINGS',
  SLA_TREND_V2 = 'SLA_TREND_V2',
  SLA_V2_SEVERITY_CHANGE_START_OPTION = 'SLA_V2_SEVERITY_CHANGE_START_OPTION',
  AI_RISK_MANAGEMENT = 'AI_RISK_MANAGEMENT',
  AGENTIC_ASSET = 'AGENTIC_ASSET',
  ORCA_SECURITY_SHIFTLEFT_BRANCH_DISABLED = 'ORCA_SECURITY_SHIFTLEFT_BRANCH_DISABLED',
  ASSET_AQL_V2 = 'ASSET_AQL_V2',
  FINDING_DETAIL_OLD_VIEW = 'FINDING_DETAIL_OLD_VIEW',
  SPLIT_TOOL_PROJECT_DISCOVERED = 'SPLIT_TOOL_PROJECT_DISCOVERED',
  DEPRECATED_LACEWORK_S3_FLOW_ENABLED = 'DEPRECATED_LACEWORK_S3_FLOW_ENABLED',
  TEAM_VIEW_CONSOLIDATED_ROWS = 'TEAM_VIEW_CONSOLIDATED_ROWS',
  SNOW_ASSETS_MULTI_LEVEL_ATTRIBUTES = 'SNOW_ASSETS_MULTI_LEVEL_ATTRIBUTES',
  SNOW_ASSETS_MULTI_LEVEL_ATTRIBUTES_APPLICATION = 'SNOW_ASSETS_MULTI_LEVEL_ATTRIBUTES_APPLICATION',
  ENABLE_SCALABLE_GROUP_ROLE_MAPPING_FLOW = 'ENABLE_SCALABLE_GROUP_ROLE_MAPPING_FLOW',
  CRA = 'CRA',
  ATTACK_PATH_FINDINGS_INGESTION = 'ATTACK_PATH_FINDINGS_INGESTION',
  JFROG_VISION_VDOO_VERSION_DISCOVERY = 'JFROG_VISION_VDOO_VERSION_DISCOVERY',
  GITHUB_SECRET_SCAN_REALTIME_INGESTION = 'GITHUB_SECRET_SCAN_REALTIME_INGESTION',
  COMPONENT_SOURCE_TOOL_ENABLE = 'COMPONENT_SOURCE_TOOL_ENABLE',
  SNOW_VR_DETECTIONS = 'SNOW_VR_DETECTIONS',
  SCM_AUTO_DISCOVERY_ENABLED_BITBUCKET = 'SCM_AUTO_DISCOVERY_ENABLED_BITBUCKET',
  SNOW_VR_DET_CREATION = 'SNOW_VR_DET_CREATION',
  SCM_AUTO_DISCOVERY_ENABLED_AZURE_REPOS = 'SCM_AUTO_DISCOVERY_ENABLED_AZURE_REPOS',
  SCM_AUTO_DISCOVERY_ENABLED_GITHUB = 'SCM_AUTO_DISCOVERY_ENABLED_GITHUB',
  RISK_SCORE_CEILING_ESCALATION = 'RISK_SCORE_CEILING_ESCALATION',
  RISK_SCORE_FINDING_ESCALATION = 'RISK_SCORE_FINDING_ESCALATION',
  GLOBAL_EXCEPTION_TEAM_SELECTION = 'GLOBAL_EXCEPTION_TEAM_SELECTION',
  SNOW_CMDB_RELATIONAL_ENRICHMENT = 'SNOW_CMDB_RELATIONAL_ENRICHMENT',
  GSCC_USE_BIGQUERY_EXPORT = 'GSCC_USE_BIGQUERY_EXPORT',
  ACTIVE_CONTRIBUTOR_WINDOW_FILTER = 'ACTIVE_CONTRIBUTOR_WINDOW_FILTER',
  ANYA_AGENT_RUNBOOK = 'ANYA_AGENT_RUNBOOK',
  PM_DEMO = 'PM_DEMO',
  ALLOW_BITBUCKET_UPDATE = 'ALLOW_BITBUCKET_UPDATE',
  ANYA_CHAT_V2_POC = 'ANYA_CHAT_V2_POC',
  GM_CUSTOM_FINDING_SCORE = 'GM_CUSTOM_FINDING_SCORE',
  WABTEC_CUSTOM_RISK_SCORING = 'WABTEC_CUSTOM_RISK_SCORING',
  ASSET_SCORE_DECIMAL_PRECISION = 'ASSET_SCORE_DECIMAL_PRECISION',
  DISNEY_FONTS = 'DISNEY_FONTS',
  FINDING_SLA_V2_RECALCULATION_HIERARCHY_SCOPE = 'FINDING_SLA_V2_RECALCULATION_HIERARCHY_SCOPE',
  MULTIPART_SCAN_UPLOAD = 'MULTIPART_SCAN_UPLOAD',
  ENABLE_QUALYS_INFRA_INCLUDE_IGNORED_VULNERABILITIES = 'ENABLE_QUALYS_INFRA_INCLUDE_IGNORED_VULNERABILITIES',
  ADD_AWS_ORG_USING_CLOUDFORMATION = 'ADD_AWS_ORG_USING_CLOUDFORMATION',
  AWS_CLOUD_FEATURE_ONBOARDING = 'AWS_CLOUD_FEATURE_ONBOARDING',
  CUSTOMIZE_SIDE_BAR = 'CUSTOMIZE_SIDE_BAR',
  ENABLE_MAPPED_GIT_CONTRIBUTORS = 'ENABLE_MAPPED_GIT_CONTRIBUTORS',
  RUNBOOK_IMAGE_MAPPING_TRACK_SUBPRODUCT_BY_TAG = 'RUNBOOK_IMAGE_MAPPING_TRACK_SUBPRODUCT_BY_TAG',
  CROWDSTRIKE_INFRA_CID_BASED_MAPPING = 'CROWDSTRIKE_INFRA_CID_BASED_MAPPING',
  MODIFIED_CVSS_FINDING_SCORE = 'MODIFIED_CVSS_FINDING_SCORE',
  RESOURCES_MODAL = 'RESOURCES_MODAL',
  CUSTOM_ATTR_NULL_FILTER = 'CUSTOM_ATTR_NULL_FILTER',
  ANYA_CREATE_PR = 'ANYA_CREATE_PR',
  FINDING_AGE_V2 = 'FINDING_AGE_V2',
  FINDING_SCORE_MODIFIERS = 'FINDING_SCORE_MODIFIERS',
  INTUNE_PATCH_MANAGEMENT = 'INTUNE_PATCH_MANAGEMENT',
  EXCEPTION_EXTENSION_IMPROVEMENTS = 'EXCEPTION_EXTENSION_IMPROVEMENTS',
  AIEM_RECO_INTEGRATION = 'AIEM_RECO_INTEGRATION',
  NEW_CVSS_METADATA_WRITE = 'NEW_CVSS_METADATA_WRITE',
  ENDOR_LABS_NAMESPACE_TRAVERSAL = 'ENDOR_LABS_NAMESPACE_TRAVERSAL',
  GIT_AUTODETECT_DEFAULT_BRANCH = 'GIT_AUTODETECT_DEFAULT_BRANCH',
  SNYK_CUSTOM_STATUS_MAPPING = 'SNYK_CUSTOM_STATUS_MAPPING',
}

/** Mapped type: all feature keys → boolean. Used as the API response type for /user/feature-flag. */
export type FeatureFlagValues = { [key in FeatureKeys]: boolean };
